import { Link } from 'react-router-dom'
import { site } from '@/content/site'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { useTypewriter } from '@/hooks/useTypewriter'
import styles from './HomePage.module.css'

export function HomePage() {
  useDocumentTitle()
  const { text } = useTypewriter(site.heroPhrases)

  return (
    <>
      {/* The splash photo. Fixed to the viewport so it stays put while the page
          scrolls, the way `background-attachment: fixed` did on the original
          site — without that property's repaint cost and its iOS quirks. */}
      <div className={styles.backdrop} aria-hidden="true" />

      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <p className={styles.greeting}>Hi, I&rsquo;m</p>
          <h1 className={styles.headline}>
            {/* The live text is announced once, not on every keystroke. */}
            <span aria-hidden="true">
              {text}
              <span className={styles.caret} />
            </span>
            <span className="sr-only">
              {site.name}, {site.role}
            </span>
          </h1>
          <p className={styles.intro}>{site.intro}</p>

          {site.availability && (
            <p className={styles.availability}>
              <span className={styles.availabilityDot} aria-hidden="true" />
              {site.availability}
            </p>
          )}

          <div className={styles.actions}>
            <Link to="/projects" className={styles.primaryAction}>
              See my work
            </Link>
            <Link to="/about" className={styles.secondaryAction}>
              About me
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
